import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

/* -----------------------------------------------------------
   Pre-hydration theme setup — runs before React mounts so the
   page doesn't flash the wrong theme.
   ----------------------------------------------------------- */
(function initTheme() {
  try {
    const stored = localStorage.getItem("vx_theme"); // "light" | "dark" | null(=system)
    const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
    const isDark = stored === "dark" || (!stored && prefersDark) || (stored !== "light" && stored !== "dark" && stored !== null && prefersDark);
    const root = document.documentElement;
    if (isDark) {
      root.classList.add("dark");
      root.style.colorScheme = "dark";
    } else {
      root.style.colorScheme = "light";
    }
  } catch (e) {
    /* ignore — theme will fall back to light */
  }
})();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
